mutation AddModalFieldsUpdate($input: AddModalFieldsUpdateInput!) {
    addModalFieldsUpdate(input: $input) {
        fieldId
        isRequired
        isRemoveable
    }
}
